<template>
    <span
        v-for="ssoType in ssoTypes"
        :key="ssoType"
    >
        <DButton
            v-if="userPermissions.includes('customer.view') && fulfillmentAccount !== null"
            :disabled="isInLoadingState"
            :label="getSsoLabel(ssoType)"
            class="me-1 pointer-events"
            @click="navigateToSSO(ssoType)"
        />
    </span>
</template>

<script setup>
import _ from 'lodash'
import { __ } from '~@/Composables/translation'
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'

const props = defineProps({
    fulfillmentAccount: {
        type: Object,
        default: () => ({})
    },
    ssoTypes: {
        type: Array,
        default: () => []
    }
})

const emit = defineEmits(['navigateToSSO'])

const userPermissions = computed(() => usePage().props.auth.permissions)

const getSsoLabel = (type) => {
    let moduleName = (_.capitalize(props.fulfillmentAccount.group.module))

    if (props.fulfillmentAccount.group.module === 'kamp_dhp') {
        moduleName = 'Kamp DHP'
    }

    if (props.fulfillmentAccount.group.module === 'kamp_colocation') {
        moduleName = 'Kamp Colocation'
    }

    if (type === 'direct_admin') {
        type = 'Directadmin'
    }

    if (type === 'default' && props.fulfillmentAccount.group.module === 'webcard') {
        moduleName = ''
    }
    const translationKeyForType = 'customers.sso.types.' + props.fulfillmentAccount.group.module + '.' + type
    const typeTranslated = __(translationKeyForType) === translationKeyForType ? type : __(translationKeyForType)
    return __('customers.contracts.login', {
        module_name: (type !== 'default') ? typeTranslated : moduleName
    })
}

const navigateToSSO = (type) => {
    emit('navigateToSSO', type)
}
</script>

<style lang="scss" scoped>
.pointer-events {
    pointer-events: auto !important;
}
</style>
